import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import GoogleSignInButton from '../components/GoogleSignInButton';

const C = { primary: '#8B1A1A' };

const inputStyle = {
  width: '100%',
  padding: '12px 14px',
  border: '1.5px solid #e0d0d0',
  borderRadius: 4,
  fontSize: 14,
  outline: 'none',
  fontFamily: 'Lato, sans-serif',
};

export default function Register() {
  const navigate = useNavigate();
  const { register, googleLogin } = useAuth();
  const [form, setForm] = useState({ username: '', email: '', first_name: '', last_name: '', password: '', password2: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.password2) { setError('Passwords do not match.'); return; }
    if (form.password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    setLoading(true);
    setError('');
    try {
      await register(form);
      navigate('/');
    } catch (err) {
      const data = err.response?.data;
      if (data) {
        const msg = Object.values(data).flat().join(' ');
        setError(msg || 'Registration failed.');
      } else {
        setError('Registration failed. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleCredential = async (credential) => {
    setError('');
    await googleLogin(credential);
    navigate('/');
  };

  const fieldStyle = { marginBottom: 16 };
  const labelStyle = { display: 'block', fontSize: 13, fontWeight: 600, color: '#555', marginBottom: 6 };

  return (
    <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ background: '#fff', borderRadius: 10, padding: '48px 40px', width: '100%', maxWidth: 460, boxShadow: '0 4px 24px rgba(139,26,26,0.1)' }}>
        <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 28, color: '#2C2C2C', textAlign: 'center', marginBottom: 8 }}>Create Account</h1>
        <p style={{ textAlign: 'center', color: '#888', marginBottom: 32, fontSize: 14 }}>Join A1 Looks and discover ethnic fashion</p>

        <form onSubmit={handleSubmit}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div style={fieldStyle}>
              <label style={labelStyle}>First Name</label>
              <input style={inputStyle} name="first_name" value={form.first_name} onChange={handleChange} placeholder="First name" />
            </div>
            <div style={fieldStyle}>
              <label style={labelStyle}>Last Name</label>
              <input style={inputStyle} name="last_name" value={form.last_name} onChange={handleChange} placeholder="Last name" />
            </div>
          </div>
          <div style={fieldStyle}>
            <label style={labelStyle}>Username *</label>
            <input style={inputStyle} name="username" value={form.username} onChange={handleChange} required />
          </div>
          <div style={fieldStyle}>
            <label style={labelStyle}>Email *</label>
            <input style={inputStyle} type="email" name="email" value={form.email} onChange={handleChange} required />
          </div>
          <div style={fieldStyle}>
            <label style={labelStyle}>Password *</label>
            <input style={inputStyle} type="password" name="password" value={form.password} onChange={handleChange} required minLength={8} />
          </div>
          <div style={{ marginBottom: 24 }}>
            <label style={labelStyle}>Confirm Password *</label>
            <input style={inputStyle} type="password" name="password2" value={form.password2} onChange={handleChange} required />
          </div>

          {error && <p style={{ color: '#e53935', fontSize: 13, marginBottom: 16, textAlign: 'center' }}>{error}</p>}

          <button
            type="submit"
            disabled={loading}
            style={{ width: '100%', padding: '13px', background: loading ? '#ccc' : C.primary, color: '#fff', border: 'none', borderRadius: 4, fontSize: 15, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer' }}
          >
            {loading ? 'Creating account…' : 'Create Account'}
          </button>
        </form>

        {process.env.REACT_APP_GOOGLE_CLIENT_ID && (
          <>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, margin: '24px 0' }}>
              <span style={{ flex: 1, height: 1, background: '#eadede' }} />
              <span style={{ color: '#999', fontSize: 12, textTransform: 'uppercase' }}>or</span>
              <span style={{ flex: 1, height: 1, background: '#eadede' }} />
            </div>
            <GoogleSignInButton
              onCredential={handleGoogleCredential}
              onError={setError}
            />
          </>
        )}

        <p style={{ textAlign: 'center', marginTop: 24, fontSize: 14, color: '#666' }}>
          Already have an account?{' '}
          <Link to="/login" style={{ color: C.primary, fontWeight: 600, textDecoration: 'none' }}>Sign in</Link>
        </p>
      </div>
    </div>
  );
}
